export default {
  common: {
    esg: {
      category: '类别',
      environment: '环境',
      society: '社会',
      governance: '管理',
      other: '其他',
      comprehensive: '综合',
      // basic: '',
    },
    btn: {
      cancel: '取消',
      add: '添加',
      create: '创建',
      update: '更新',
      apply: '应用',
      close: '关闭',
      create_new: '新建',
      edit: '编辑',
      detail: '详细信息',
      view_detail: '详细信息',
      delete: '删除',
      change: '切换',
      confirm: '确认',
      clear: '清除条件（重置条件）',
      download: '下载',
      save: '保存',
      register: '注册',
      check_answer: '确认回答',
      score_card_list: '得分卡一览',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: '批量下载',
    },
    link: {
      delete: '删除',
      back: '返回',
    },
    sentence: {
      back_to_login: '返回登录页面',
      back_to_dashboard: '返回仪表板',
      not_applicable: '对象之外※',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: '调查表',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: '请选择调查表',
      target_year: '年份',
      target_year_text: '请选择年份。',
      target_company: '公司',
      target_company_text: '请选择公司。',
      total: '总计{total}件',
    },
    label: {
      required: '必填',
      optional: '任意',
      year: '年度',
    },
    form: {
      search_word: {
        label: '自由词搜索',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: '发布日',
      evaluation_expires_date: '有效期',
      answer_expires_date: '回答截止时间',
      // last_updated_date: '',
    },
    error: {
      code_0005: '验证失败。请重新登录。',
      code_0007: '此项为必填项。',
      code_5001: '未找到页面。',
      code_0001: '已在最新的问题中提出。',
      code_0002: '无法更新，因为已从其他设备更新数据。请重新加载后再次进行该操作。',
      code_0003: '无法删除文件。请至少回答一个问题后再删除。',
      code_0006: '该用户已注册。',
      code_0004: '超出可上传文件的大小。单个文件最大为50MB。',
      code_9999: '发生了意外错误。',
    },
    evaluation: {
      title: '委托评估',
      dashboard: '仪表板',
      analysis: '分析',
      list: '公司一览',
    },
    dashboard: {
      title: '仪表板',
    },
    upload: {
      title: '调查表',
      common: '通用',
    },
    scorecard: {
      title: '得分卡',
      list: '一览',
      detail: '详细信息',
      scorecard_detail: '得分卡详细信息',
      answer_preview: '回答预览',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: '改进计划',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: '应用分析',
    },
    settings: {
      title: '设置',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: '常见问题',
    },
    logout: {
      title: '登出',
    },
    industry: {
      type_1: '农林渔业',
      type_2: '矿业·采石业·砂石开采业',
      type_3: '建筑业（包括设备工程业）',
      type_4: '制造业（钢铁·有色金属·金属制品）',
      type_5: '制造业（机械仪器·电子设备等）',
      type_6: '制造业（食品·饮料·香烟等）',
      type_7: '制造业（纸浆·纸·纸加工品）',
      type_8: '制造业（木材·木制品等加工）',
      type_9: '制造业（化学工业（包括医药品）·纤维工业）',
      type_10: '制造业（石油·煤炭·橡胶·塑料等）',
      type_11: '制造业（印刷业）',
      type_12: '制造业（其他）',
      type_13: '供电、供气、供暖',
      type_14: '通信',
      type_15: '运输业·仓储业',
      type_16: '批发业·零售业',
      type_17: '金融业·保险业',
      type_18: '房地产业',
      type_19: '学校（包括幼儿园和托儿所）',
      type_20: '住宿业·餐饮服务业',
      type_21: '生活相关服务业（洗衣·理发·美容·浴池业等）',
      type_22: '医疗·福利',
      type_23: '废弃物处理·回收业',
      type_24: '汽车保养业',
      type_25: '地方政府·行政机关等',
      type_26: '其他',
    },
    scale: {
      a: '1〜29 人',
      b: '30〜99 人',
      c: '100〜499 人',
      d: '500〜999 人',
      e: '1000〜4999 人',
      f: '5000人〜',
    },
    sales_amount: {
      under_1million: '1亿日元以下',
      under_10million: '1亿~10亿日元',
      under_100million: '10亿~100亿日元',
      under_1billion: '100亿~1,000亿日元',
      under_10billion: '1,000亿~1兆日元',
      over_10billion: '1兆日元以上~',
      not_disclose: '不想回答',
    },
    progress: '完成率',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: '明细',
    help: '帮助',
    user_display_mode: {
      my_assessment: '公司内部评估',
      supply_chain_assessment: '供应链评估',
    },
    buyer: '委托评估公司',
    supplier: '被评估企业',
    error_page: {
      section_one: '找不到页面',
      section_two: '请确认URL',
      to_dashboard: '返回仪表板',
    },
    priority: {
      good: '良好',
      high: '高',
      medium: '中等',
      low: '低',
    },
    priority_full_name: {
      high: '高风险',
      medium: '中等风险',
      low: '低风险',
    },
    faq: {
      how_to_use_csv_head: '请按照以下步骤在Excel中打开下载的CSV文件。',
      how_to_use_csv_body_01: '1. 打开一个新的空白Excel工作簿。',
      how_to_use_csv_body_02: '2. 在[数据]选项卡中点击[来自文本或 CSV]。',
      how_to_use_csv_body_03: '3. 选择目标 .csv 文件，然后点击[导入]。',
      how_to_use_csv_body_04: '4. 确认显示的数据内容没有问题。',
      how_to_use_csv_body_05: '5. 选择[加载]。',
      how_to_use_csv_note: '※ 具体步骤因您所使用的OS及Microsoft Excel的版本而异。',
    },
    answer_display_status: {
      unanswered: '未回答',
      temporarily_saved: '答复中',
      submitted: '已答复',
      score_rated: '已完成评估',
      ended: '已完成',
    },
    all: '所有',
    count: {
      // question: '',
      company: ' 公司',
      unit: '件',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: '进度',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: '请输入',
      half_digits: '半角数字',
    },
  },
};
